import { Box, Button, HStack, Heading, Image, Mark, Stack, Text, VStack } from '@chakra-ui/react'
import {CgGoogle,CgYoutube} from 'react-icons/cg'
import {SiCoursera,SiUdemy} from 'react-icons/si'
import introVideo from '../../assets/videos/intro.mp4'
import {DiAws} from 'react-icons/di'
import React from 'react'
import './home.css'
import vg from '../../assets/images/bg.png'
import { Link, matchRoutes } from 'react-router-dom'
const Home = () => {
  return (
    <section className='home'>
        <div className="container">
        <Stack direction={['column','row']}
        height='100%'
        justifyContent={['center','space-between']}
        alignItems='center'
        spacing={['16','56']}
        >
  <VStack
  width={'full'} alignItems={['center','flex-end']} spacing='8'
  >
<Heading children="LEARN FROM THE EXPERTS" size={'2×1'} />
<Text fontFamily={'cursive'}  fontSize={'2×1'} textAlign={['center','left']} children="Find Valuable Content At Reasonable Price"/>
<Link to='courses'>
    <Button size='lg' colorScheme='yellow'>
        Explore Now
    </Button>
</Link>
  </VStack>

  <Image className='vector-graphics' boxSize={'md'} src={vg} objectFit='contain'/>
        </Stack>
        </div>
        <Box padding={'8'} bg='blackAlpha.800'>
            <Heading textAlign={'center'} fontFamily='body' color={'yellow.400'} children="OUR BRANDS"/>
            <HStack className='brandsBanner' justifyContent={'space-evenly'} marginTop='4'> 
<CgGoogle/>
<CgYoutube/>
<CgGoogle/>
<SiCoursera/>
<SiUdemy/>
<DiAws/>
            </HStack>
        </Box>

        <div className="container2">
            <video autoPlay={true} controls controlsList='nodownload nofullscreen noremoteplayback' disablePictureInPicture disableRemotePlayback src={introVideo}>

            </video>
        </div>
    </section>
  )
}

export default Home